@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="continer-fliud px-2">
    <div class="apply-leave-form my-3" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="col-12 leave-form-heading">
        <h1> Apply Resignation</h1>
      </div>
      <form class="pt-4" #f="ngForm" (ngSubmit)="onSubmit(f)">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group form-field" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
              <label for="" class="pl-4">Designation</label>
              <input type="text" name="designation" class="form-control pl-4" placeholder="Type here" ngModel
                #designation="ngModel" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group form-field " [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                <label for="" class="pl-4">Employee Type</label>
                <select (change)="calculateLastWorkingDay(f)" name="employment_status" data-toggle="dropdown"
                  class="dropdown-toggle checks-dropdown form-control selectpicker" ngModel #employment_status="ngModel">
                  <option value="Probation">Probation</option>
                  <option value="Permanent">Permanent</option>
                </select>
                <i class="fa fa-chevron-down"></i>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group form-field" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                <label for="" class="pl-4">Apply Date</label>
                <input (change)="calculateLastWorkingDay(f)" type="date" name="resign_date" ngModel #resign_date="ngModel"
                  class="form-control date-type pl-4" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group form-field" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                  <label for="" class="pl-4">Last Working Day</label>
                  <input type="date" name="last_working_date" ngModel #last_working_date="ngModel"
                    class="form-control date-type pl-4" readonly />
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group form-field" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                    <label for="" class="pl-4">Description</label>
                    <textarea class="form-control pl-4" id="" rows="3" name="resign_explanation" ngModel required
                    #resign_explanation="ngModel"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center text-sm-right form-field form-field-btn">
                <button (click)="onCancel(f)" class="btn btn-primary mr-sm-3">Cancel</button>
                <button type="submit" class="btn btn-primary mt-2 mt-sm-0">Apply</button>
              </div>


            </form>
          </div>

          <!-- zeeshan -->
          <!-- <div class="row mt-3">
          <div class="col-12">
            <div class="card shadow">
              <form #f="ngForm" (ngSubmit)="onSubmit(f)">
                <div class="card-content">
                  <h4 class="p-1 mt-2 ml-4 text-secondary font-weight-bold weekly-graph">
                    Apply Resignation
                  </h4>
                  <div class="card-body">
                    <div class="media d-flex text-secondary-light mb-5">
                      <div class="col-6">
                        <span class="text-secondary start-date">Designation</span>
                        <input type="text" name="designation" class="form-control" ngModel #designation="ngModel" />
                      </div>
                      <div class="col-6">
                        <span class="text-secondary">Employee Type</span>
                        <select (change)="calculateLastWorkingDay(f)" name="employment_status" data-toggle="dropdown"
                          class="dropdown-toggle checks-dropdown form-control" ngModel #employment_status="ngModel">
                          <option value="Probation">Probation</option>
                          <option value="Permanent">Permanent</option>
                        </select>
                      </div>
                    </div>

                    <div class="media d-flex text-secondary-light mb-5">
                      <div class="col-6">
                        <span class="text-secondary start-date">Apply Date</span>
                        <input (change)="calculateLastWorkingDay(f)" type="date" name="resign_date" ngModel
                          #resign_date="ngModel" class="form-control date-type" />
                        </div>
                        <div class="col-6">
                          <span class="text-secondary end-date">Last Working Day</span>
                          <input type="date" name="last_working_date" ngModel #last_working_date="ngModel"
                            class="form-control date-type" readonly />
                          </div>
                        </div>

                        <div class="media d-flex text-secondary-light mb-5">
                          <div class="col description">
                            <span class="text-secondary start-date">Description</span>
                            <textarea style="width: 100%; height: 170px" class="form-control" rows="5" name="resign_explanation"
                              ngModel required #resign_explanation="ngModel">
                            </textarea>
                          </div>
                        </div>

                        <div class="media d-flex text-secondary-light mb-5 time-detail">
                          <div class="col-6">
                            <button type="button" (click)="onCancel(f)" class="btn btn float-right cancel">Cancel</button>
                          </div>
                          <div class="col-6">
                            <button type="submit" class="btn btn apply">Apply</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div> -->
          </div>
        </main>